export class Configuration {
    constructor(
        public crimeStatisticsReportUrl: string,
        public PaypalClientIDsandbox: string,
        public PaypalClientIDproduction: string,
        public Paypalenv: string,
        public PhoenixKey: string,
        public AdminUser: string,
        public AdminPwd: string,
        /**
         * Set IdleUserTimout in seconds (20min*60sec = 1200)
        */
        public SessionTimout: number,
        public DomainDocument: string,
        public AdminDocument: string,
        public GoogleMapApiKey: string,
        public ClientID: string,
        public EmployementAppURL: string
    ) { }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/config.model.ts